<h4 class="font-weight-bold py-3 mb-4">Add New Certificate</h4>
<!--<p>This page is an example of basic layout. For more options use <strong>Angular starter template generator</strong> in the docs.</p>-->
<!--<p><button class="btn btn-primary btn-lg">Button</button></p>-->
<div class="card mb-4">
  <h6 class="card-header">
    Add Certificate
  </h6>
  <div class="card-body">
    <form>
      <div class="form-row">
        <div class="form-group col-md-12">
          <div class="dropzone" [dropzone]="dropzoneConfig" (error)="fileUploaded()">
            <div class="dz-message needsclick">
              Drop files here or click to upload
            </div>
          </div>
        </div>
        <div class="form-group col-md-4">
          <label class="form-label">Reference</label>
          <div class="input-group">
            <input name="identifier" type="text" class="form-control" placeholder="Reference" [(ngModel)]="certificate.identifier">
          </div>
        </div>
        <div class="form-group col-md-4">
          <label class="form-label">Expiry Date</label>
          <div class="input-group">
            <input name="expiryDate" class="form-control" placeholder="yyyy-mm-dd" name="dp"
                   ngbDatepicker
                   [(ngModel)]="certificate.expiryDate"
                   [displayMonths]="2"
                   [navigation]="'select'"
                   [disabled]="false"
                   #d="ngbDatepicker">
            <div class="input-group-append">
              <button class="input-group-text" [disabled]="false" (click)="d.toggle()" type="button">
                <span class="ion ion-md-calendar" style="cursor: pointer;"></span>
              </button>
            </div>
          </div>
        </div>
        <div class="form-group col-md-4">
          <label class="form-label">Issuer</label>
          <input name="issuer" type="text" class="form-control" [(ngModel)]="certificate.issuer" [ngbTypeahead]="search"
                 [placement]="'bottom-left'" placeholder="Issuer">
<!--          <input name="issuer" type="text" class="form-control" placeholder="Issuer" [(ngModel)]="certificate.issuer">-->
        </div>
      </div>
      <div class="form-group">
        <label class="form-label">Description</label>
        <input name="description" type="text" class="form-control" placeholder="Description" [(ngModel)]="certificate.description">
      </div>
      <button type="submit" class="btn btn-primary" (click)="addCertificate()">Add</button>
    </form>
  </div>
</div>

